import React from "react";
export default function CompactionNotice() {
  return (
    <div className="ev ev--notice">
      <em>Conversation history was compacted to fit context.</em>
    </div>
  );
}
